module.exports = __webpack_public_path__ + "static/media/antenna_3.615b701a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/antenna_3.jpeg
// module id = 1442
// module chunks = 0